/* eslint-disable prefer-const */
import { PureComponent } from 'react';
import { isNil } from 'lodash';
import { injectIntl } from 'react-intl';

// UTILS
import { intl } from 'utils';

// COMPONENTS
import { Select } from 'componentsV2/Select';

import withFormikInput from './withFormikInput';
import withFormField from './withFormField';
import withDependentFields from 'componentsV2/Fields/withDependentFields';

class _SelectInput extends PureComponent {
  static defaultProps = {
    value: undefined,
    defaultSelected: undefined,
  };

  onChange = (data) => {
    // @ts-expect-error TS(2339): Property 'onChange' does not exist on type 'Readon... Remove this comment to see the full error message
    this.props.onChange({
      target: {
        type: 'select',
        // @ts-expect-error TS(2339): Property 'name' does not exist on type 'Readonly<{... Remove this comment to see the full error message
        name: this.props.name,
        value: data.value,
      },
    });
  };

  onBlur = (event) => {
    // @ts-expect-error TS(2339): Property 'name' does not exist on type 'Readonly<{... Remove this comment to see the full error message
    event.target.name = this.props.name;
    // @ts-expect-error TS(2339): Property 'onBlur' does not exist on type 'Readonly... Remove this comment to see the full error message
    this.props.onBlur(event);
  };

  _getOptions = () => {
    // @ts-expect-error TS(2339): Property 'options' does not exist on type 'Readonl... Remove this comment to see the full error message
    let { options } = this.props;

    if (typeof options === 'function') {
      options = options(this.props);
    }

    options = options.map((option) => ({
      ...option,
      // @ts-expect-error TS(2339): Property 'intl' does not exist on type 'Readonly<{... Remove this comment to see the full error message
      label: intl.maybeTranslate(option.label, this.props.intl),
    }));

    return options;
  };

  findSelectedInChoices(item) {
    if (!isNil(item)) {
      const val = typeof item === 'object' ? item.value : item;

      return this._getOptions().find((opt) => String(opt.value) === String(val)) || null;
    }

    return null;
  }

  render() {
    let {
      // @ts-expect-error TS(2339): Property 'fluid' does not exist on type 'Readonly<... Remove this comment to see the full error message
      fluid,
      // @ts-expect-error TS(2339): Property 'name' does not exist on type 'Readonly<{... Remove this comment to see the full error message
      name,
      // @ts-expect-error TS(2339): Property 'value' does not exist on type 'Readonly<... Remove this comment to see the full error message
      value,
      // @ts-expect-error TS(2339): Property 'defaultSelected' does not exist on type ... Remove this comment to see the full error message
      defaultSelected,
      // @ts-expect-error TS(2339): Property 'label' does not exist on type 'Readonly<... Remove this comment to see the full error message
      label,
      // @ts-expect-error TS(2339): Property 'onChange' does not exist on type 'Readon... Remove this comment to see the full error message
      onChange,
      // @ts-expect-error TS(2339): Property 'onBlur' does not exist on type 'Readonly... Remove this comment to see the full error message
      onBlur,
      // @ts-expect-error TS(2339): Property 'touched' does not exist on type 'Readonl... Remove this comment to see the full error message
      touched,
      // @ts-expect-error TS(2339): Property 'options' does not exist on type 'Readonl... Remove this comment to see the full error message
      options,
      // @ts-expect-error TS(2339): Property 'setFieldTouched' does not exist on type ... Remove this comment to see the full error message
      setFieldTouched,
      // @ts-expect-error TS(2339): Property 'placeholder' does not exist on type 'Rea... Remove this comment to see the full error message
      placeholder,
      ...rest
    } = this.props;

    value = isNil(value) ? defaultSelected : value;
    value = this.findSelectedInChoices(value);

    return (
      <Select
        {...rest}
        // @ts-expect-error TS(2322): Type '{ onChange: (data: any) => void; onBlur: (ev... Remove this comment to see the full error message
        onChange={this.onChange}
        onBlur={this.onBlur}
        value={value}
        options={this._getOptions()}
        placeholder={placeholder}
      />
    );
  }
}

function withSetTouchedOnChange(Component) {
  return (props) => {
    const { onChange, touched, ...rest } = props;

    const _onChange = (data, action) => {
      if (!props.touched) {
        props.setFieldTouched(props.name, true);
      }
      onChange(data, action);
    };

    return <Component {...rest} onChange={_onChange} />;
  };
}

/**
 * @deprecated Please use `Select` from `components/Select` instead.
 */
// @ts-expect-error TS(2769): No overload matches this call.
export const SelectInput = injectIntl(_SelectInput);

/**
 * @deprecated Please use `Select` from `components/Select` instead.
 */
export const FormSelectWithDependentFields = withFormikInput(
  withFormField(withDependentFields(withSetTouchedOnChange(SelectInput))),
  {
    passProps: ['setFieldTouched', 'setFieldValue', 'touched'],
  }
);

/**
 * @deprecated Please use `Select` from `components/Select` instead.
 */
const FormSelect = withFormikInput(withFormField(withSetTouchedOnChange(SelectInput)), {
  passProps: ['setFieldTouched'],
});

export default FormSelect;
